import { createI18n } from 'vue-i18n'
import { store } from "@/store/store"

const i18n = createI18n({
    legacy: false,
    allowComposition: true,
    locale: store.state.activeLang,
    globalInjection: true,
    messages: store.state.messages
})

export default i18n
